/**
 * The fixtures' "now". Pinned so every relative timestamp ("3m ago", "Today")
 * renders identically on every run, and screenshots taken weeks apart match.
 *
 * 14:20 UTC on 22 October 2026: mid-afternoon in Europe, late morning in New
 * York, so the mock inboxes read as a working day in both.
 */
export const NOW_ISO = "2026-10-22T14:20:00.000Z";
export const NOW = new Date(NOW_ISO);
export const NOW_MS = NOW.getTime();

export const SECOND = 1_000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const WEEK = 7 * DAY;

export function iso(ms: number): string {
  return new Date(ms).toISOString();
}

/** `ago(2, "h")` → ISO string two hours before NOW. */
export function ago(amount: number, unit: "s" | "m" | "h" | "d" | "w"): string {
  const ms =
    unit === "s"
      ? SECOND
      : unit === "m"
        ? MINUTE
        : unit === "h"
          ? HOUR
          : unit === "d"
            ? DAY
            : WEEK;
  return iso(NOW_MS - amount * ms);
}

/** `ahead(2, "h")` → ISO string two hours after NOW, for calendar slots. */
export function ahead(amount: number, unit: "m" | "h" | "d"): string {
  const ms = unit === "m" ? MINUTE : unit === "h" ? HOUR : DAY;
  return iso(NOW_MS + amount * ms);
}

/** The current billing month (UTC): October 2026. */
export const PERIOD_START_MS = Date.UTC(2026, 9, 1);
export const PERIOD_END_MS = Date.UTC(2026, 10, 1);

/** How far through the billing period NOW sits, 0 to 1. */
export const PERIOD_FRACTION =
  (NOW_MS - PERIOD_START_MS) / (PERIOD_END_MS - PERIOD_START_MS);
